"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.merchantContractsFetchData = void 0;
const types_1 = require("@framework/types");
const types_2 = require("../types");
exports.merchantContractsFetchData = {
    [types_2.ServiceType.ADMIN]: [types_1.TokenType.ERC721, types_1.TokenType.ERC998, types_1.TokenType.ERC1155],
    [types_2.ServiceType.OFFICE]: [types_1.TokenType.ERC721, types_1.TokenType.ERC1155],
};
//# sourceMappingURL=marketplace-contracts.js.map